export default "__VITE_ASSET__b737efac__"